export var DiningOptionPropertyTypeEnum;
(function (DiningOptionPropertyTypeEnum) {
    DiningOptionPropertyTypeEnum["STRING"] = "string";
    DiningOptionPropertyTypeEnum["BOOLEAN"] = "boolean";
    DiningOptionPropertyTypeEnum["TIMESTAMP"] = "timestamp";
    DiningOptionPropertyTypeEnum["INT8"] = "int8";
    DiningOptionPropertyTypeEnum["UINT8"] = "uint8";
    DiningOptionPropertyTypeEnum["INT16"] = "int16";
    DiningOptionPropertyTypeEnum["UINT16"] = "uint16";
    DiningOptionPropertyTypeEnum["INT32"] = "int32";
    DiningOptionPropertyTypeEnum["UINT32"] = "uint32";
    DiningOptionPropertyTypeEnum["FLOAT32"] = "float32";
    DiningOptionPropertyTypeEnum["FLOAT64"] = "float64";
})(DiningOptionPropertyTypeEnum || (DiningOptionPropertyTypeEnum = {}));
//# sourceMappingURL=DiningOptionPropertyTypeEnum.js.map